export default __webpack_public_path__ + "static/media/trainer.3913ab48.png";